module.exports = __webpack_public_path__ + "img/les-plus-dj-background.3cd32c3f.png";